import {
  apiRoutes,
  getDistrictsFn,
  type DefaultQueryError,
  type District,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const useGetDistricts = (
  params: {
    provinceId: string;
  },
  opts?: UseQueryOptions<District[], DefaultQueryError>
) =>
  useQuery<District[], DefaultQueryError>({
    queryKey: [apiRoutes.intercity.districts(params.provinceId)],
    queryFn: () => getDistrictsFn(params.provinceId),
    ...opts,
  });
